import { useId } from 'react';
import { Button, Text, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';

const useStyles = makeStyles({
  card: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: tokens.spacingHorizontalM,
    paddingBlock: tokens.spacingVerticalM, paddingInline: tokens.spacingHorizontalL,
    backgroundColor: tokens.colorNeutralBackground1,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusLarge,
  },
  text: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXXS, minWidth: 0 },
  title: { margin: 0, fontSize: tokens.fontSizeBase400, lineHeight: tokens.lineHeightBase400, fontWeight: tokens.fontWeightSemibold },
});

/**
 * What Offer and stage offers a person who is past Candidate and has no other offer in flight: one
 * action, "Draft a new offer" (a redo, or a change of terms). It sits under the 2.5 outcome card
 * and starts the same editor a candidate's offer does, seeded from the signed offer's terms when
 * there is one. A viewer has no action, so nothing is drawn for them.
 */
export function NewOfferForHire({ canEdit, busy, hasSigned, onDraft }: {
  readonly canEdit: boolean;
  readonly busy: boolean;
  readonly hasSigned: boolean;
  readonly onDraft: () => void;
}) {
  const styles = useStyles();
  const headingId = useId();
  if (!canEdit) return null;
  return (
    <section className={styles.card} aria-labelledby={headingId}>
      <div className={styles.text}>
        <h3 id={headingId} className={styles.title}>Offers</h3>
        <Text size={200}>{hasSigned ? 'Start from the signed offer’s terms to redo it or change them.' : 'No offer is on record for this person.'}</Text>
      </div>
      <Button appearance="secondary" disabled={busy} onClick={onDraft}>Draft a new offer</Button>
    </section>
  );
}
